import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class SerialNumberQueryCriteriaClass extends BaseCriteriaModel {

  //for the header(s)
    namespace?: Optional<string> = Optional.empty();
    sn_type?: Optional<string> = Optional.empty();
    sn_id?: Optional<string> = Optional.empty();

  //for the extension(s)
    param_name?: Optional<string> = Optional.empty();
    param_code?: Optional<string> = Optional.empty();
    ext_hdr_guid?: Optional<string> = Optional.empty();

  //for the line(s)
    item_code?: Optional<string> = Optional.empty();
    line_hdr_guid?: Optional<string> = Optional.empty();
}

export class SerialNumberCriteriaModelQuery {
  query = '';

  constructor(SerialNumberCriteriaModel: SerialNumberQueryCriteriaClass) {

    if (!SerialNumberCriteriaModel) {
      return;
    }

    this.query += SerialNumberCriteriaModel.namespace.filter(x => x !== '').map(x => '&namespace=' + x).orElse('');
    this.query += SerialNumberCriteriaModel.sn_type.filter(x => x !== '').map(x => '&sn_type=' + x).orElse('');
    this.query += SerialNumberCriteriaModel.sn_id.filter(x => x !== '').map(x => '&sn_id=' + x).orElse('');
    this.query += SerialNumberCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += SerialNumberCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += SerialNumberCriteriaModel.ext_hdr_guid.filter(x => x !== '').map(x => '&ext_hdr_guid=' + x).orElse('');
    this.query += SerialNumberCriteriaModel.item_code.filter(x => x !== '').map(x => '&item_code=' + x).orElse('');
    this.query += SerialNumberCriteriaModel.line_hdr_guid.filter(x => x !== '').map(x => '&line_hdr_guid=' + x).orElse('');

    this.query += '&status=' + SerialNumberCriteriaModel.status;
    this.query += '&orderBy=' + SerialNumberCriteriaModel.orderBy;
    this.query += '&order=' + SerialNumberCriteriaModel.order;
    this.query += '&offset=' + SerialNumberCriteriaModel.offset + '&limit=' + SerialNumberCriteriaModel.limit;
  }
}
